import { render, staticRenderFns } from "./AccreditationUsers.vue?vue&type=template&id=811704d8&scoped=true"
import script from "./AccreditationUsers.vue?vue&type=script&lang=js"
export * from "./AccreditationUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811704d8",
  null
  
)

export default component.exports